import { render, staticRenderFns } from "./Indiegogo.vue?vue&type=template&id=7af4e9e9&"
import script from "./Indiegogo.vue?vue&type=script&lang=js&"
export * from "./Indiegogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports